import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "width": "100%",
    "height": "100%"
  }
};
import VueOfficeExcel from '@vue-office/excel';
import '@vue-office/excel/lib/index.css';
export default /*#__PURE__*/_defineComponent({
  __name: 'Excel',
  props: {
    fileUrl: {}
  },
  emits: ['error', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const errorHandler = error => {
      emit('error', error);
    };
    const renderedHandler = () => {
      emit('success');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(VueOfficeExcel), {
        style: {
          "width": "100%",
          "height": "100%"
        },
        src: _ctx.fileUrl,
        onError: errorHandler,
        onRendered: renderedHandler
      }, null, 8, ["src"])]);
    };
  }
});